import { createSlice } from "@reduxjs/toolkit";
import initialState from "./initial-state";

const { actions, reducer } = createSlice({
  name: "memberReducer",
  initialState,
  reducers: {
    setCounterIncrement(state) {
      state.counter += 1;
    },
    setCounterDecrement(state) {
      state.counter -= 1;
    },
    setMember(state, actions) {
      state.member = actions.payload;
    },
    setMemPersonalInfo(state, actions) {
      state.member.personalInfo = actions.payload;
    },
    setMemRasiKatam(state, actions) {
      state.member.rasiKatam = actions.payload;
    },
    setMemRasiPlanets(state, actions) {
      state.member.rasiPlanets = actions.payload;
    },
    setMemNavamsaKatam(state, actions) {
      state.member.navamsaKatam = actions.payload;
    },
    setMemNavamsaPlanets(state, actions) {
      state.member.navamsaPlanets = actions.payload;
    },
    setMemResidentialAddress(state, actions) {
      state.member.residentialAddress = actions.payload;
    },
    setMemContactDetails(state, actions) {
      state.member.contactDetails = actions.payload;
    },
    setMemOccupationDetails(state, actions) {
      state.member.occupation = actions.payload;
    },
    setMemHoroscopeDetails(state, actions) {
      state.member.horoscopeDetails = actions.payload;
    },
    setMemFamilyDetails(state, actions) {
      state.member.familyDetails = actions.payload;
    },
    setMemBirthDetails(state, actions) {
      state.member.birthDetails = actions.payload;
    },
    setMemQualification(state, actions) {
      state.member.qualification = actions.payload;
    },
    setVerificationDetails(state, actions) {
      state.member.verificationDetails = actions.payload;
    },
    setEatingHabits(state, actions) {
      state.member.eatingHabits = actions.payload;
    },
    setDrinkingHabits(state, actions) {
      state.member.drinkingHabits = actions.payload;
    },
    setsmokingHabits(state, actions) {
      state.member.smokingHabits = actions.payload;
    },
    setMemProfileDetails(state, actions) {
      state.member.createdBy = actions.payload.createdBy;
      state.member.horoscopeImage = actions.payload.horoscopeImage;
      state.member.lookingFor = actions.payload.lookingFor;
      state.member.ownHouse = actions.payload.ownHouse;
      state.member.startDate = actions.payload.startDate;
      state.member.otherIncome = actions.payload.otherIncome;
      state.member.propertyDetails = actions.payload.propertyDetails;
    },
  },
});

export { actions };
export default reducer;
